import { render, staticRenderFns } from "./PanelProvisionAgreementsListAdmin.vue?vue&type=template&id=1350f8e0&scoped=true&"
import script from "./PanelProvisionAgreementsListAdmin.vue?vue&type=script&lang=js&"
export * from "./PanelProvisionAgreementsListAdmin.vue?vue&type=script&lang=js&"
import style0 from "floating-vue/dist/style.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./PanelProvisionAgreementsListAdmin.vue?vue&type=style&index=1&id=1350f8e0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1350f8e0",
  null
  
)

export default component.exports